module.exports = __webpack_public_path__ + "img/deviceType.9ab28b66.png";